module.exports = __webpack_public_path__ + "static/media/ordinary-day.ce545c9b.png";